import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsDestinationDetailResponse } from "../../Orchestrator/Types/Interface/ICmsDestination";

export async function getCmsDestinationBySlug(
  slug: string
): Promise<IApiResponse<ICmsDestinationDetailResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getDestinationsAPI;

  const params = new URLSearchParams();
  const locale = await getLocaleFromCookie();

  params.append("filters[slug][$eq]", slug);
  params.append("populate[booking_routes][populate]", "*");
  params.append("populate[stays][populate]", "*");
  params.append("populate[famous_places][populate]", "*");
  params.append("populate[top_restaurants][populate]", "*");
  params.append("populate[image]", "true");
  params.append("populate[full]", "true");
  params.append("locale", locale);

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsDestinationDetailResponse>(
    endpointWithParams,
    "GET"
  );
}
